<template>
  <router-link :to="to" :class="[fonstSize, 'weight-500 cursor-pointer inline-flex-row items-center text-text1 gap-8']">
    <SvgIcon icon="Default-Circle_Arrow_Left" :style="{ width: '1em', height: '1em' }" />
    <slot />
  </router-link>
</template>

<script setup lang="ts">
const props = defineProps({
  size: {
    validator(value: string) {
      return ['large', 'default', 'small'].indexOf(value) > -1;
    },
    type: String,
    default: 'default'
  },
  to: {
    type: [String, Object],
    default: ''
  }
});

const fonstSize = computed(() => {
  switch (props.size) {
  case 'large':
    return 'f18';
  case 'small':
    return 'f14';
  default:
    return 'f16';
  }
});
</script>